import { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { chPerm, scrollTo } from 'src/components/helpers';
import EntryModal from './tablero-gestion/EntryModal';
import CardsGridView from './tablero-gestion/components/CardsGridView';
import EntryContentView from './tablero-gestion/components/EntryContentView';
import { Container, LoadingContainer } from './tablero-gestion/styles/TrainingViewStyles';
import { separateEntriesByReadStatus } from './tablero-gestion/utils/trainingViewUtils';
import { isEntryReadByUser } from './tablero-gestion/utils/tableroGestionUtils';
import TrainingContext, {
  TrainingContextProvider,
} from './tablero-gestion/components/hooks/TrainingContext';

const TrainingViewContent = () => {
  const isAdmin = chPerm(['intranetAdmin'], true);
  const context = useContext(TrainingContext);

  if (!context) {
    return (
      <Container>
        <LoadingContainer>
          <p>Cargando...</p>
        </LoadingContainer>
      </Container>
    );
  }

  const {
    entries,
    loading,
    modalOpen,
    editingEntry,
    markingAsRead,
    interactions,
    loadingInteractions,
    selectedEntry,
    currentUserId,
    setModalOpen,
    handleEntrySelect,
    handleBack,
    handleCreateEntry,
    handleEditEntry,
    handleSaveEntry,
    handleMarkAsReadAndUpdate,
    fetchInteractions,
  } = context;

  const handleEntrySelectWithScroll = (entry) => {
    handleEntrySelect(entry);
    scrollTo(0, 0);
  };

  const handleBackWithScroll = () => {
    handleBack();
    scrollTo(0, 0);
  };

  // Separate entries by read status
  const { unreadEntries, readEntries } = separateEntriesByReadStatus(
    entries,
    currentUserId,
    isEntryReadByUser
  );

  if (loading) {
    return (
      <Container>
        <LoadingContainer>
          <p>Cargando...</p>
        </LoadingContainer>
      </Container>
    );
  }

  // Show entry content view
  if (selectedEntry) {
    return (
      <Container>
        <EntryContentView
          entry={selectedEntry}
          currentUserId={currentUserId}
          isAdmin={isAdmin}
          markingAsRead={markingAsRead}
          onBack={handleBackWithScroll}
          interactions={interactions}
          loadingInteractions={loadingInteractions}
          onEdit={handleEditEntry}
          onMarkAsRead={handleMarkAsReadAndUpdate}
          fetchInteractions={fetchInteractions}
          onEntryUpdated={(updatedEntry) => {
            if (updatedEntry && context.setSelectedEntry) {
              context.setSelectedEntry(updatedEntry);
            }
            context.fetchBulletins();
          }}
        />

        {isAdmin && (
          <div
            style={{
              position: 'fixed',
              bottom: '2rem',
              right: '2rem',
              zIndex: 1000,
            }}
            className="create-button-container"
          >
            <Button
              primary
              icon="plus"
              content="Crear Entrada"
              onClick={handleCreateEntry}
              size="large"
              style={{
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              }}
            />
          </div>
        )}

        <EntryModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          entry={editingEntry}
          onSave={handleSaveEntry}
        />
      </Container>
    );
  }

  // Show cards grid view
  return (
    <Container>
      <CardsGridView
        unreadEntries={unreadEntries}
        readEntries={readEntries}
        entries={entries}
        isAdmin={isAdmin}
        onEntrySelect={handleEntrySelectWithScroll}
        currentUserId={currentUserId}
      />

      {isAdmin && (
        <div
          style={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            zIndex: 1000,
          }}
          className="create-button-container"
        >
          <Button
            primary
            icon="plus"
            content="Crear Entrada"
            onClick={handleCreateEntry}
            size="large"
            style={{
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            }}
          />
        </div>
      )}

      <EntryModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        entry={editingEntry}
        onSave={handleSaveEntry}
      />
    </Container>
  );
};

const TrainingView = () => {
  return (
    <TrainingContextProvider>
      <TrainingViewContent />
    </TrainingContextProvider>
  );
};

export default TrainingView;
